var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.entity === "LOADING"
    ? _c(
        "div",
        { staticClass: "layout-column flex-center" },
        [_c("rbv-loading", { attrs: { label: "Loading, please wait..." } })],
        1
      )
    : _c("div", [
        _c("div", { class: _vm.$style.header }, [
          _vm.isVerified
            ? _c("div", { class: _vm.$style.headerStatus }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: _vm.$style.headerStatusIcon,
                  },
                  [_vm._v("check_circle")]
                ),
                _c("span", { class: _vm.$style.headerStatusLabel }, [
                  _vm._v("Verified " + _vm._s(_vm.type)),
                ]),
              ])
            : _vm.isObsolete
            ? _c("div", { class: _vm.$style.headerStatus }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: _vm.$style.headerStatusIcon,
                  },
                  [_vm._v("info")]
                ),
                _c("span", { class: _vm.$style.headerStatusLabel }, [
                  _vm._v("Obsolete " + _vm._s(_vm.type)),
                ]),
              ])
            : _c("div", { class: _vm.$style.headerStatus }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: _vm.$style.headerStatusIcon,
                  },
                  [_vm._v("info")]
                ),
                _c("span", { class: _vm.$style.headerStatusLabel }, [
                  _vm._v("Unverified " + _vm._s(_vm.type)),
                ]),
              ]),
          _c("h2", { class: _vm.$style.headerTitle }, [
            _vm._v(" " + _vm._s(_vm.entity.name) + " "),
          ]),
        ]),
        _c("div", { class: _vm.$style.section }, [
          _c("div", { class: _vm.$style.sectionHeading }, [
            _c(
              "div",
              {
                staticClass: "material-icons",
                class: _vm.$style.sectionHeadingIcon,
              },
              [_vm._v(" business_center ")]
            ),
            _c("div", { class: _vm.$style.sectionHeadingLabel }, [
              _vm._v(" Basic Information "),
            ]),
            _c("div", [
              _vm.isAdmin
                ? _c(
                    "button",
                    {
                      staticClass: "rbButton smallIcon",
                      on: { click: _vm.edit },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("mode_edit"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _c("div", { class: _vm.$style.sectionContent }, [
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v(" Company Name "),
              ]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v(" " + _vm._s(_vm.entity.name) + " "),
              ]),
            ]),
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v(" Industry "),
              ]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v(" " + _vm._s(_vm.industry) + " "),
              ]),
            ]),
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v(" Address "),
              ]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v(" " + _vm._s(_vm.address || "-") + " "),
              ]),
            ]),
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v(" Company URL "),
              ]),
              _vm.website
                ? _c("div", { class: _vm.$style.detailsValue }, [
                    _c(
                      "a",
                      {
                        class: _vm.$style.website,
                        attrs: { href: _vm.website, target: "_blank" },
                      },
                      [_vm._v(" " + _vm._s(_vm.website) + " ")]
                    ),
                  ])
                : _c("div", { class: _vm.$style.detailsValue }, [
                    _vm._v(" - "),
                  ]),
            ]),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }